import { Injectable } from '@angular/core';
import { PaymentResponseType } from '@app/shared/models/userBalance';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastCtrl: ToastController, private translateService: TranslateService) {}
  defautlDuration = 0;
  closeBtnText: string = this.translateService.instant('DISMISS')
  toastButtons = [{
    // side: 'end',
    // icon: 'close',
    role: 'cancel',
    htmlAttributes: {
        'aria-label': this.closeBtnText,
    },
    text: this.closeBtnText,
    cssClass: 'toast-button-color',
  }];

  async presentToast(message: string, duration: number = 0, cssClass: string = 'toast-truce') {
    const toastMsg = this.translateService.instant(message);
    const toast = await this.toastCtrl.create({
      htmlAttributes: { tabindex: undefined },
      message: toastMsg,
      duration: 0,
      cssClass,
      buttons: this.toastButtons
    });
    return await toast.present();
  }

  async presentToastWithOptions(
    message: string,
    duration: number = 5000,
    postion: 'bottom' | 'middle' | 'top' = 'bottom',
    cssClass: string = 'toast-truce',
    showCloseBtn: boolean = true,
    closeBtnText: string = this.translateService.instant('DISMISS')
  ) {
    const buttons = [];
    if (showCloseBtn) {
      buttons.push({
        side: 'end',
        icon: 'close',
        role: 'cancel',
        text: closeBtnText,
        cssClass: 'toast-button-color',
      });
    }
    const toast = await this.toastCtrl.create({
      htmlAttributes: { tabindex: undefined },
      message,
      position: postion,
      cssClass,
      duration,
      buttons,
    });
    toast.present();
  }

  async presentErrorToast(message?: string) {
    try {
      await this.toastCtrl.dismiss();
    } catch (e) {}
    const toast = await this.toastCtrl.create({
      message: this.translateService.instant(message ?? 'THERE_IS_SOME_ISSUE_PLEASE_TRY_AGAIN'),
      duration: this.defautlDuration,
      color: 'danger',
      buttons: this.toastButtons
    });
    toast.present();
  }

  async presentPaymentToaster(type, msg = '') {
    const message = msg
      ? msg
      : type === PaymentResponseType.success
      ? 'PAYMENT_SUCCESS'
      : 'PAYMENT_FAILED';
    const toast = await this.toastCtrl.create({
      message: this.translateService.instant(message),
      color: type === PaymentResponseType.success ? 'success' : 'danger',
      duration: this.defautlDuration,
      buttons: this.toastButtons
    });
    await toast.present();
  }

  // async showAlertReactivateRequest() {
  //   return new Promise(async (resolve: any) => {
  //     const toast = await this.toastCtrl.create({
  //       header: 'Account Suspended',
  //       message: 'You have previously cancelled your Pure Matrimony Account. Do you wish to reactivate your account?',
  //       position: 'bottom',
  //       buttons: [
  //         {
  //           side: 'end',
  //           role: 'cancel',
  //           text: 'Cancel',
  //           handler: () => {
  //             resolve(false);
  //           }
  //         }, {
  //           text: 'Reactivate',
  //           handler: () => {
  //             resolve(true);
  //           }
  //         }
  //       ]
  //     });
  //     await toast.present();
  //   });
  // }

  async showErrorToast(
    msg: string = 'THERE_IS_SOME_ISSUE_PLEASE_TRY_AGAIN',
    duration: number =  this.defautlDuration
  ) {
    {
      const message = this.translateService.instant(msg);
      const toast = await this.toastCtrl.create({
        message,
        color: 'danger',
        duration,
        buttons: this.toastButtons
      });
      toast.present();
    }
  }
  async showSuccessToast(msg: string, duration: number = 2000) {
    {
      const message = this.translateService.instant(msg);
      const toast = await this.toastCtrl.create({
        message,
        color: 'success',
        duration: this.defautlDuration,
        buttons: this.toastButtons
      });
      toast.present();
    }
  }
  async showWarningToast(msg: string, duration: number = 2000) {
    {
      const message = this.translateService.instant(msg);
      const toast = await this.toastCtrl.create({
        message,
        color: 'warning',
        duration: this.defautlDuration,
        buttons: this.toastButtons
      });
      toast.present();
    }
  }
}
